var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipticalRing = function SvgEllipticalRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 82",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M43.6631 77.7644C64.7062 77.7644 81.7538 61.2007 81.7539 40.782C81.7539 20.3631 64.7063 3.79864 43.6631 3.79858C22.6199 3.79858 5.57227 20.3631 5.57227 40.782C5.57239 61.2008 22.6199 77.7644 43.6631 77.7644Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M43.6631 77.7644C64.7062 77.7644 81.7538 61.2007 81.7539 40.782C81.7539 20.3631 64.7063 3.79864 43.6631 3.79858C22.6199 3.79858 5.57227 20.3631 5.57227 40.782C5.57239 61.2008 22.6199 77.7644 43.6631 77.7644Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M43.6631 77.7644C64.7062 77.7644 81.7538 61.2007 81.7539 40.782C81.7539 20.3631 64.7063 3.79864 43.6631 3.79858C22.6199 3.79858 5.57227 20.3631 5.57227 40.782C5.57239 61.2008 22.6199 77.7644 43.6631 77.7644Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M43.6631 77.7644C64.7062 77.7644 81.7538 61.2007 81.7539 40.782C81.7539 20.3631 64.7063 3.79864 43.6631 3.79858C22.6199 3.79858 5.57227 20.3631 5.57227 40.782C5.57239 61.2008 22.6199 77.7644 43.6631 77.7644Z",
    stroke: "url(#paint0_linear_18_1405)",
    strokeWidth: 0.44703
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.5728 81.3401C65.5968 81.34 82.6636 63.1946 82.6636 40.7815C82.6634 18.3686 65.5967 0.223934 44.5728 0.223877C23.5488 0.223877 6.48212 18.3686 6.48193 40.7815C6.48193 63.1946 23.5487 81.3401 44.5728 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.5728 81.3401C65.5968 81.34 82.6636 63.1946 82.6636 40.7815C82.6634 18.3686 65.5967 0.223934 44.5728 0.223877C23.5488 0.223877 6.48212 18.3686 6.48193 40.7815C6.48193 63.1946 23.5487 81.3401 44.5728 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.5728 81.3401C65.5968 81.34 82.6636 63.1946 82.6636 40.7815C82.6634 18.3686 65.5967 0.223934 44.5728 0.223877C23.5488 0.223877 6.48212 18.3686 6.48193 40.7815C6.48193 63.1946 23.5487 81.3401 44.5728 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.5728 81.3401C65.5968 81.34 82.6636 63.1946 82.6636 40.7815C82.6634 18.3686 65.5967 0.223934 44.5728 0.223877C23.5488 0.223877 6.48212 18.3686 6.48193 40.7815C6.48193 63.1946 23.5487 81.3401 44.5728 81.3401Z",
    stroke: "url(#paint1_linear_18_1405)",
    strokeWidth: 0.44703
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M42.751 81.3401C66.1043 81.3401 84.9948 64.2964 84.9951 43.3196C84.9951 22.3426 66.1045 5.2981 42.751 5.2981C19.3975 5.29812 0.506836 22.3426 0.506836 43.3196C0.507104 64.2964 19.3977 81.3401 42.751 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M42.751 81.3401C66.1043 81.3401 84.9948 64.2964 84.9951 43.3196C84.9951 22.3426 66.1045 5.2981 42.751 5.2981C19.3975 5.29812 0.506836 22.3426 0.506836 43.3196C0.507104 64.2964 19.3977 81.3401 42.751 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M42.751 81.3401C66.1043 81.3401 84.9948 64.2964 84.9951 43.3196C84.9951 22.3426 66.1045 5.2981 42.751 5.2981C19.3975 5.29812 0.506836 22.3426 0.506836 43.3196C0.507104 64.2964 19.3977 81.3401 42.751 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M42.751 81.3401C66.1043 81.3401 84.9948 64.2964 84.9951 43.3196C84.9951 22.3426 66.1045 5.2981 42.751 5.2981C19.3975 5.29812 0.506836 22.3426 0.506836 43.3196C0.507104 64.2964 19.3977 81.3401 42.751 81.3401Z",
    stroke: "url(#paint2_linear_18_1405)",
    strokeWidth: 0.44703
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M41.3062 81.3401C61.6346 81.34 78.1499 63.2017 78.1499 40.7815C78.1497 18.3614 61.6345 0.224006 41.3062 0.223877C20.9777 0.223877 4.46258 18.3613 4.4624 40.7815C4.4624 63.2018 20.9776 81.3401 41.3062 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M41.3062 81.3401C61.6346 81.34 78.1499 63.2017 78.1499 40.7815C78.1497 18.3614 61.6345 0.224006 41.3062 0.223877C20.9777 0.223877 4.46258 18.3613 4.4624 40.7815C4.4624 63.2018 20.9776 81.3401 41.3062 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M41.3062 81.3401C61.6346 81.34 78.1499 63.2017 78.1499 40.7815C78.1497 18.3614 61.6345 0.224006 41.3062 0.223877C20.9777 0.223877 4.46258 18.3613 4.4624 40.7815C4.4624 63.2018 20.9776 81.3401 41.3062 81.3401Z",
    stroke: "#CC7722",
    strokeOpacity: 0.1,
    strokeWidth: 0.44703
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M41.3062 81.3401C61.6346 81.34 78.1499 63.2017 78.1499 40.7815C78.1497 18.3614 61.6345 0.224006 41.3062 0.223877C20.9777 0.223877 4.46258 18.3613 4.4624 40.7815C4.4624 63.2018 20.9776 81.3401 41.3062 81.3401Z",
    stroke: "url(#paint3_linear_18_1405)",
    strokeWidth: 0.44703
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_1405",
    x1: 43.663,
    y1: 77.988,
    x2: 43.663,
    y2: 3.57549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_1405",
    x1: 44.5727,
    y1: 81.5637,
    x2: 44.5727,
    y2: -0.0000152588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_1405",
    x1: 42.751,
    y1: 81.5637,
    x2: 42.751,
    y2: 5.07455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_1405",
    x1: 41.3059,
    y1: 81.5637,
    x2: 41.3059,
    y2: -0.0000152588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944345"
  })))));
};
export default SvgEllipticalRing;